





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import ListSaveWidget from '@/components/ListSaveWidget.vue';

import { ListModel } from '@/models/list-model';

import { UserModule, UserStore } from '@/store/modules/user';

import { MutationPayload } from 'vuex';

import 'share-api-polyfill';

@Component({
  components: {
    ListSaveWidget
  }
})
export default class BigListEndCard extends Vue {
  @Prop(ListModel) list: ListModel;

  isSaved: boolean = false;

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }

  clickShare() {
    // @ts-ignore
    navigator.share({
      title: this.list.title,
      text: this.list.description,
      url: this.list.link
    })
  }

  checkIsSaved() {
    this.isSaved = UserModule.savedListIds.indexOf(this.list.id) > -1;
  }

  mounted() {
    this.checkIsSaved();

    this.$store.subscribe((mutation: MutationPayload, state: any) => {
      if (mutation.type === UserStore.SET_SAVED_LIST_IDS_MUTATION) {
        this.checkIsSaved();
      }
    });
  }

  get saveIcon() {
    if (!this.isSaved) {
      return require('@/assets/images/icon__sharp-bookmark_border-24px.svg');
    } else {
      return require('@/assets/images/icon__sharp-bookmark-24px.svg');
    }
  }
}
